import { Tooltip } from '@ads/components-react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

export interface BannerFieldLabelProps {
  readonly label: string;
  /** Explicação do campo — vai para o tooltip do ícone, não para a tela. */
  readonly info?: string | undefined;
  /** Marca o campo como obrigatório com `*` depois do rótulo. */
  readonly required?: boolean;
}

/**
 * Rótulo de campo do formulário de Banner com a explicação em **tooltip**.
 *
 * As regras de cada campo (o que a Url faz, de onde vem a duração, o que conta
 * como turma ativa) ficam atrás de um ícone de informação em vez de virarem
 * parágrafos abaixo do campo: o formulário é longo e o texto corrido competia
 * com os próprios campos.
 */
export function BannerFieldLabel({ label, info, required = false }: BannerFieldLabelProps) {
  return (
    <span className="flex items-center gap-quark ts-subtitle-xxs text-ctx-content-title">
      {required ? `${label}*` : label}
      {info ? (
        <Tooltip title={info} custom={{ root: 'z-[60] max-w-[18rem]' }}>
          <InformationCircleIcon className="size-xxxs shrink-0 text-ctx-content-base" />
        </Tooltip>
      ) : null}
    </span>
  );
}
